
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import { EqualDepth, Group, Raycaster } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'


/* LOAD MODEL */
const test_gltf = new URL('../assets/name.glb', import.meta.url)
const assetLoader = new GLTFLoader();
assetLoader.load(test_gltf.href, (gltf) => {
    const model = gltf.scene
    var newMaterial = new THREE.MeshStandardMaterial({
        color: 0x243b55,
        transparent: true,
        opacity: .2,
        roughness: 0,
        metalness: 1,
        wireframe: true,
    });
    model.traverse((o) => {
        if (o.isMesh) o.material = newMaterial;
    });

    var bbox = new THREE.Box3();
    var cent = new THREE.Vector3();
    bbox.setFromObject(model);
    bbox.getCenter(cent);

    console.log("actual center ", cent);
    model.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
            child.geometry.translate(-cent.x, -cent.y, -cent.z);
            child.rotateX(1.65)
        }
    });
    scene.add(model)
    model.name = 'heroModel'
}, undefined, function (error) {
    console.error(error)
})

/* RENDERER */
const container = document.querySelector('[data-hero-container]')
const renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
});
renderer.shadowMap.enabled = true;
renderer.setSize(container.clientWidth, container.clientHeight / 2);
renderer.domElement.classList.add('hero__canvas')
renderer.domElement.setAttribute('data-hero', '')
renderer.setClearColor(0x000000, 0);
renderer.setPixelRatio(window.devicePixelRatio);
container.appendChild(renderer.domElement);
const scene = new THREE.Scene();

/* CAMERA */
const camera = new THREE.PerspectiveCamera(
    11,
    window.innerWidth / window.innerHeight * 2,
    0.1,
    1000
)
camera.position.set(20, 0, 30)
//const orbit = new OrbitControls(camera, renderer.domElement)
const axesHelper = new THREE.AxesHelper(30)
scene.add(axesHelper)
scene.fog = new THREE.FogExp2(0x000000, 0.01)
const textureLoader = new THREE.TextureLoader();
//scene.background = textureLoader.load(popps)
const cubeTextureLoader = new THREE.CubeTextureLoader()
/* scene.background = cubeTextureLoader.load([
    popps,
    popps,
    popps,
    popps,
    popps,
    popps
]) */

//orbit.update()


/* LIGHTS */
const ambientLight = new THREE.AmbientLight(0x333333)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 1)
scene.add(directionalLight)
directionalLight.position.set(-30, 10, 10)
directionalLight.castShadow = true;
const directionalLightTarget = new THREE.Object3D()
scene.add(directionalLightTarget)
directionalLight.target = directionalLightTarget
const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight)
//scene.add(directionalLightHelper)
const directionalLightShadowHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
//scene.add(directionalLightShadowHelper)

const spotLight = new THREE.SpotLight(0xffffff)
scene.add(spotLight)
spotLight.position.set(-100, 100, 0)
spotLight.castShadow = true;
spotLight.angle = 0.1;
const spotLightHelper = new THREE.SpotLightHelper(spotLight)
//scene.add(spotLightHelper)


/* GUI */
/* const gui = new dat.GUI();
const options = {
    sphereColor: '#ffea00',
    wireframe: false,
    speed: 0.01,
    angle: 0.2,
    penumbra: 0.2,
    intensity: .8,
    cameraPosX: 0,
    cameraPosY: 0,
    cameraPosZ: 0,
}
gui.addColor(options, 'sphereColor').onChange(function (e) {
    sphere.material.color.set(e);
})
gui.add(options, 'wireframe').onChange((e) => {
    sphere.material.wireframe = e;
})
gui.add(options, 'speed', 0, 0.1)
gui.add(options, 'angle', 0, 1).onChange((e) => {
    spotLight.angle = e
})
gui.add(options, 'penumbra', 0, 1).onChange((e) => {
    spotLight.penumbra = e
})
gui.add(options, 'intensity', 0, 1).onChange((e) => {
    spotLight.intensity = e
})
gui.add(options, 'cameraPosX', -10, 10).onChange((e) => {
    camera.position.setX(e)
})
gui.add(options, 'cameraPosY', -10, 10).onChange((e) => {
    camera.position.setY(e)
})
gui.add(options, 'cameraPosZ', -10, 10).onChange((e) => {
    camera.position.setZ(e)
}) */


/* EVENTHANDLERS */
function addEventHandlers() {
    window.addEventListener('click', onMouseClick, false);
    window.addEventListener('pointermove', onPointerMove, false);
    window.addEventListener('resize', onWindowResize, false);
}

window.addEventListener('resize', onWindowResize, false);
function onWindowResize() {
    camera.aspect = container.clientWidth / container.clientHeight * 2;
    camera.updateProjectionMatrix();

    renderer.setSize(container.clientWidth, container.clientHeight / 2);

}

/* ANIMATION */
document.addEventListener('mousemove', onDocumentMouseMove)

let mouseX = 0
let mouseY = 0

let targetX = 0
let targetY = 0

const windowHalfX = window.innerWidth / 2
const windowHalfY = window.innerHeight / 2

function onDocumentMouseMove(event) {
    mouseX = (event.clientX - windowHalfX)
    mouseY = (event.clientY - windowHalfY)
}

const clock = new THREE.Clock()

const tick = () => {

    targetX = mouseX * .005
    targetY = mouseY * .0005

    const elapsedTime = clock.getElapsedTime() / 1

    model = scene.getObjectByName('heroModel')
    if (model) {
        model.rotation.y = .05 * elapsedTime
        model.rotation.y += .05 * (targetX - model.rotation.y)
        model.rotation.x += .005 * (targetY - model.rotation.x)
        model.position.z += -.005 * (targetY - model.rotation.x)

        //camera.position.y = (camera.position.y += (targetX / 300))
        // camera.position.x = (camera.position.x += (targetY / 300))
        //.makeRotationY(.005 * elapsedTime))
    }
    // Update objects
    /* sphere.rotation.y += .5 * (targetX - sphere.rotation.y)
    sphere.rotation.x += .05 * (targetY - sphere.rotation.x)
    sphere.position.z += -.05 * (targetY - sphere.rotation.x) */
    /*    camera.lookAt(new THREE.Vector3(-4 + (targetX / 10), (targetY / 10), (targetY / 20)));
       camera.position.y = (camera.position.y += (targetX / 300))
       camera.position.x = (camera.position.x += (targetY / 300))
       camera.position.z = (camera.position.z += (targetY / 300)) */

    // Update Orbital Controls
    // controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()


console.log(scene.getObjectByName('heroModel'));
THREE.DefaultLoadingManager.onLoad = function () {
    camera.lookAt(new THREE.Vector3(-4, 0, 0));
    removeLoader()
};
